const getDefaultState = () => ({
    companyId: undefined
});

export default {
    namespaced: true,
    state: getDefaultState(),

    getters: {
        getAllData(state) {
            return state;
        },

        getCompanyId(state) {
            return state.companyId;
        },
    },

    mutations: {
        CLEAR(state) {
            // eslint-disable-next-line no-param-reassign
            Object.assign(state, getDefaultState());
        },

        SET_COMPANY_ID(state, val) {
            state.companyId = val;
        },
    },
};
